/**
 * Recording Controls Component
 * Knoppen voor opname beheer (start, pause, resume, stop, retry).
 */

import React from 'react';
import './RecordingControls.css';

interface RecordingControlsProps {
  isRecording: boolean;
  isPaused: boolean;
  canStart: boolean;
  onStart: () => void;
  onPause: () => void;
  onResume: () => void;
  onStop: () => void;
  disabled?: boolean;
  /** Toon de "Opnieuw proberen"-knop (na mislukte upload) */
  canRetry?: boolean;
  onRetry?: () => void;
  /** Nieuw gesprek starten na mislukte upload (verwijdert pending record) */
  onNewConversation?: () => void;
}

export const RecordingControls: React.FC<RecordingControlsProps> = ({
  isRecording,
  isPaused,
  canStart,
  onStart,
  onPause,
  onResume,
  onStop,
  disabled = false,
  canRetry = false,
  onRetry,
  onNewConversation,
}) => {
  // Na een mislukte upload: retry + nieuw gesprek
  if (canRetry) {
    return (
      <div className="recording-controls">
        <button className="btn btn-retry" onClick={onRetry} disabled={disabled}>
          <span className="btn-icon">🔄</span>
          <span>Opnieuw proberen</span>
        </button>
        <button className="btn btn-record" onClick={onNewConversation} disabled={disabled}>
          <span className="btn-icon">🎤</span>
          <span>Nieuw gesprek</span>
        </button>
      </div>
    );
  }

  if (!isRecording) {
    return (
      <div className="recording-controls">
        <button
          className="btn btn-record"
          onClick={onStart}
          disabled={!canStart || disabled}
        >
          <span className="btn-icon">🎤</span>
          <span>Start Opname</span>
        </button>
      </div>
    );
  }

  return (
    <div className="recording-controls">
      {isPaused ? (
        <button className="btn btn-resume" onClick={onResume} disabled={disabled}>
          <span className="btn-icon">▶️</span>
          <span>Hervat</span>
        </button>
      ) : (
        <button className="btn btn-pause" onClick={onPause} disabled={disabled}>
          <span className="btn-icon">⏸️</span>
          <span>Pauzeer</span>
        </button>
      )}

      <button className="btn btn-stop" onClick={onStop} disabled={disabled}>
        <span className="btn-icon">⏹️</span>
        <span>Stop Opname</span>
      </button>
    </div>
  );
};
